import React, { HTMLProps } from "react";
import { Controller, Control, RegisterOptions } from "react-hook-form";

type CheckboxProps = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  label?: string;
  defaultValue?: boolean;
  rules?: RegisterOptions;
  // [key: string]: any; // For additional props like className, disabled, etc.
} & HTMLProps<HTMLInputElement>

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  control,
  label,
  defaultValue,
  rules,
  ...rest
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => {
        const inputProps = {
          type: "checkbox",
          checked: field.value as boolean,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            field.onChange(e.target.checked),
          ...rest,
        };
        return label ? (
          <label>
            <input {...inputProps} />
            {label}
          </label>
        ) : (
          <input {...inputProps} />
        );
      }}
    />
  );
};

export default Checkbox;
